import { EPaymentCreationType } from "./EPaymentCreationType";

export const OneDayPaymentTypes: ReadonlyArray<string> = [
  EPaymentCreationType.ONE_DAY,
  EPaymentCreationType.ONE_DAY_DEBIT,
  EPaymentCreationType.ONE_DAY_TAX_TRANSFER,
];
